import { type ProductUploadPopoverAnalyticsEvents } from '@autone/ui';

export const PRODUCT_UPLOAD_POPOVER_ANALYTICS_EVENTS: ProductUploadPopoverAnalyticsEvents =
  {
    uploadAnalyticsEvent: {
      clicked: {
        category: 'assortment_template_import_export',
        action: 'download_template_modal:upload_products_template_file_clicked',
      },
      success: {
        category: 'assortment_template_import_export',
        action:
          'download_template_modal:upload_products_template_file_succeeded',
      },
      error: {
        category: 'assortment_template_import_export',
        action: 'download_template_modal:upload_products_template_file_errored',
      },
    },
    downloadAnalyticsEvent: {
      clicked: {
        category: 'assortment_template_import_export',
        action:
          'download_template_modal:download_products_template_file_clicked',
      },
    },
  };
